import { useEffect, useRef } from "react";
import { useUIStore } from "@/app/state/ui-store";

/** Keeps the static CSS theme in sync with the selected appearance. */
export function ThemeBootstrap() {
    const appearance = useUIStore(state => state.appearance);
    const previousAppearanceRef = useRef<typeof appearance>();

    useEffect(() => {
        const rootElement = document.documentElement;
        const shouldAnimate = previousAppearanceRef.current !== undefined && previousAppearanceRef.current !== appearance;
        previousAppearanceRef.current = appearance;

        if (shouldAnimate) rootElement.dataset.themeTransition = "changing";
        rootElement.dataset.appearance = appearance;

        if (!shouldAnimate) return;
        const timer = window.setTimeout(() => {
            delete rootElement.dataset.themeTransition;
        }, 620);
        return () => window.clearTimeout(timer);
    }, [appearance]);

    return null;
}
